import { render } from "./DownloadDataBase.vue?vue&type=template&id=fd81aa46&scoped=true"
import script from "./DownloadDataBase.vue?vue&type=script&lang=js"
export * from "./DownloadDataBase.vue?vue&type=script&lang=js"

import "./DownloadDataBase.vue?vue&type=style&index=0&id=fd81aa46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd81aa46"]])

export default __exports__